
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppFormRow, AppSelect, AppButton } from '@/components';
import { useVersionList } from '@/modules/version/model/list';
import { ROUTE_NAME_VERSION } from '@/modules/version/router';
import { VersionOptions } from '@/modules/version/model/mixins';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_VERSION.INDEX,
    components: { AppTable, AppCard, AppFormRow, AppSelect, AppButton },
    setup() {
        const { list, total, fetchList, query, actions } = useVersionList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Id', key: 'id' },
                { type: TableColumnType.Option, label: 'Store', key: 'store', options: VersionOptions.Store },
                { type: TableColumnType.Text, label: 'Version', key: 'version' },
                { type: TableColumnType.DateTime, label: 'Released Date', key: 'releasedDate' },
                { type: TableColumnType.DateTime, label: 'Dropped Date', key: 'droppedDate' },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: VersionOptions.Status },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_VERSION.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-thumbs-up',
                        theme: 'warning',
                        tooltip: 'Undrop',
                        onclick: () => actions.undrop(row.id)
                    }),
                    canShow: (row: any) => row.canUndrop,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-thumbs-down',
                        theme: 'warning',
                        tooltip: 'Drop',
                        onclick: () => actions.drop(row.id)
                    }),
                    canShow: (row: any) => row.canDrop,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-check',
                        theme: 'success',
                        tooltip: 'Activate',
                        onclick: () => actions.activate(row.id)
                    }),
                    canShow: (row: any) => row.canActive,
                    group: 2
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { list, total, fetchList, query, table, VersionOptions, ROUTE_NAME_VERSION };
    }
});
